import { Injectable } from '@angular/core';

import { DataCollections } from '@osos/shared/api';
import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { CollectionPresenterModel } from '@osos/shared/types';
import { LovParserV1Service } from '../../parsers/lov-parser/lov-parser-v1.service';

@Injectable()
export class LovFactoryService extends FactoryBase<
  DataCollections,
  CollectionPresenterModel
> {
  constructor(parserFactory: ParserFactory, parser_v1: LovParserV1Service) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(presenter: CollectionPresenterModel): DataCollections {
    const parser = this.getParser(
      DataCollections,
      CollectionPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }
  createPresenterModel(model: DataCollections | any): CollectionPresenterModel {
    const parser = this.getParser(
      DataCollections,
      CollectionPresenterModel,
      model.specificationVersion,
    );
    const result = parser?.getPresenterModel(model);
    return result;
  }
}
